import { useState, useRef, useEffect } from "react";
import type { useU2000GridStateHandlers } from "../../../../../u2000Core/reducer/formReducer/U2000GridStateHandlers";
import { U2000FormStateEnumEditMode } from "../../../../../u2000Core/reducer/formReducer/U2000FormState";
import type { useU2000LUStateHandlers } from "../../../../../u2000Core/reducer/formReducer/U2000LUHandlers";
import { U2000LUStateEnumNextAction } from "../../../../../u2000Core/reducer/formReducer/U2000LUState";
import type { NavigateFunction } from "react-router-dom";
import type { U3121SubProject } from "../../../../U3121Service";

export interface U3121ProjectSubProjectsHandlerReturn {
  onRowClick: (sub: U3121SubProject) => void;
  onAdd: () => void;
  onModify: () => void;
  gridStateHandlers: ReturnType<typeof useU2000GridStateHandlers<U3121SubProject>>;
  setDataChangedEvent: (dataChangedEvent: number) => void;
  dataChangedEvent: number;
}

export interface U3121ProjectSubProjectsHandlerParam {
  luStateHandlers: ReturnType<typeof useU2000LUStateHandlers>;
  gridStateHandlers: ReturnType<typeof useU2000GridStateHandlers<U3121SubProject>>;
  navigate: NavigateFunction;
}

export function u3121ProjectSubProjectsHandler(params: U3121ProjectSubProjectsHandlerParam): U3121ProjectSubProjectsHandlerReturn {
  const { luStateHandlers, gridStateHandlers, navigate } = params;
  const [dataChangedEvent, setDataChangedEvent] = useState<number>(0);
  const [_localEditMode, _setLocalEditMode] = useState<U2000FormStateEnumEditMode>(U2000FormStateEnumEditMode.NONE);
  const localEditModeRef = useRef(_localEditMode);

  useEffect(() => {
    localEditModeRef.current = _localEditMode;
  }, [_localEditMode]);

  const onRowClick = (sub: U3121SubProject) => {
    luStateHandlers.setNextAction(U2000LUStateEnumNextAction.NONE);
    luStateHandlers.setActionOriginFrom(`/U3121/SUBPROJECT`);
    const currentIdx = gridStateHandlers.getData().findIndex((s) => s.id === sub.id);
    gridStateHandlers.setCurrentIdx(currentIdx);
    navigate(`subproject/${sub.id}`);
  };

  const onAdd = (): void => {
    luStateHandlers.setNextAction(U2000LUStateEnumNextAction.ADD);
    luStateHandlers.setActionOriginFrom(`/U3121/PROJECT`);
    navigate("subproject/create");
  };

  const onModify = (): void => {
    luStateHandlers.setNextAction(U2000LUStateEnumNextAction.MODIFY);
    luStateHandlers.setActionOriginFrom(`/U3121/PROJECT`);
    const selected = gridStateHandlers.getSelectedRows()[0];
    if (selected?.id) navigate(`subproject/${selected.id}`);
  };

  return {
    onRowClick,
    onAdd,
    onModify,
    gridStateHandlers,
    setDataChangedEvent,
    dataChangedEvent,
  };
}
